const STORAGE_KEY = "akinda_ref_code";

function normalizeRefCode(raw: string | null | undefined): string {
  return (raw || "").trim();
}

export function captureReferralCodeFromLocation(): string {
  if (typeof window === "undefined") return "";
  const url = new URL(window.location.href);
  const fromQuery = normalizeRefCode(url.searchParams.get("ref"));
  const path = url.pathname.replace(/^\/(en|ru|uz)(?=\/)/, "");
  const match = path.match(/^\/r\/([A-Za-z0-9]+)$/);
  const fromPath = match ? match[1] : "";
  const code = fromQuery || fromPath;
  if (code) {
    sessionStorage.setItem(STORAGE_KEY, code);
  }
  return code || getStoredReferralCode();
}

export function getStoredReferralCode(): string {
  if (typeof window === "undefined") return "";
  return normalizeRefCode(sessionStorage.getItem(STORAGE_KEY));
}

export function clearStoredReferralCode(): void {
  if (typeof window === "undefined") return;
  sessionStorage.removeItem(STORAGE_KEY);
}
